"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var modalZIndex = 1300;
var zIndex = {
    mobileStepper: 1000,
    drawer: 1200,
    datasetsHeader: modalZIndex - 3,
    topBar: modalZIndex - 2,
    sidebar: modalZIndex - 2,
    sidebarCollapseButton: modalZIndex - 1,
    unsupportedBrowserWarning: modalZIndex - 1,
    actionButton: modalZIndex - 1,
    modal: modalZIndex,
    dropdown: modalZIndex + 1,
    confirmationDialog: modalZIndex + 2,
    globalSpinner: modalZIndex + 3,
    reloadMessage: modalZIndex + 4,
    snackbar: 1400,
    developerToolbar: 1400,
    tooltip: 1500,
};
exports.default = zIndex;
